<template>
  <div
    class="bg-color-background-2 rounded-xl overflow-hidden border border-color-border hover:border-color-secondary transition-all hover:-translate-y-1 group shadow-sm relative flex flex-col h-full"
    @click="$emit('click')"
  >
    <div
      v-if="product.is_on_campaign"
      class="absolute top-2 left-2 bg-yellow-500 text-black text-[16px] font-bold px-2 py-0.5 rounded-full z-10"
    >
      تخفیف کمپین
    </div>

    <div class="relative h-40 overflow-hidden bg-color-background">
      <img
        :src="product.image || product.images?.[0] || Defaultphoto"
        @error="handleImageError"
        :alt="product.title || product.name"
        class="w-full h-full object-cover group-hover:scale-110 transition duration-500 pointer-events-none"
      />

      <div
        v-if="product.discount && product.discount > 0"
        class="absolute top-2 right-2 bg-red-500 text-white text-[16px] font-bold px-1.5 py-0.5 rounded-full"
      >
        {{ product.discount }}%
      </div>
    </div>

    <div class="p-3 flex flex-col flex-1">
      <h3
        class="text-xs h-7 md:text-sm font-semibold text-color-text-primary mb-1 line-clamp-2 min-h-[36px] group-hover:text-color-secondary transition-colors"
      >
        {{ product.title || product.name }}
      </h3>

      <div class="flex-1"></div>

      <div class="mt-auto">
        <div v-if="!ShopService.isLeadStore()" class="mb-2">
          <div class="flex flex-col gap-0.5 h-10">
            <span class="text-color-primary font-bold text-xs md:text-sm">
              {{ formatPrice(product.final_price || product.finalPrice) }}
              <span class="text-[10px] md:text-[11px]">ریال</span>
            </span>
            <span
              v-if="product.price !== product.final_price || product.oldPrice"
              class="text-gray-400 line-through text-[11px] md:text-xs"
            >
              {{ formatPrice(product.price || product.oldPrice) }}
              <span class="text-[9px] md:text-[10px]">ریال</span>
            </span>
          </div>
        </div>

        <!-- دکمه جزئیات برای محصولات موجود -->
        <button
          v-if="
            product.is_available !== false && product.status !== 'unavailable'
          "
          class="w-full py-1.5 text-[16px] md:text-xs border border-color-primary text-color-primary rounded hover:bg-color-primary hover:text-white transition-all"
        >
          جزئیات محصول
        </button>

        <!-- دکمه ناموجود -->
        <button
          v-else
          class="w-full py-1.5 text-[16px] md:text-xs border border-gray-300 text-gray-400 bg-gray-100 rounded transition-all"
        >
          {{ product.status_display || " ناموجود " }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import DefaultPhotoImg from "@/assets/Defaultphoto.png";
import ShopService from "@/api/services/shopService";

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["click"]);
const router = useRouter();
const Defaultphoto = DefaultPhotoImg;

const formatPrice = (price) => {
  if (!price && price !== 0) return "0";
  return new Intl.NumberFormat("fa-IR").format(price);
};

const handleImageError = (event) => {
  if (event.target.src !== Defaultphoto) {
    event.target.src = Defaultphoto;
  }
};
</script>